module.exports = __webpack_public_path__ + "images/ideal-1f61974eb13d4e26983e569dca4c6318.svg";